import { useState, useEffect } from "react";

const APP_VERSION_KEY = "MemoryOSwebAppV";

function compareVersions(newVersion, oldVersion) {
  const newParts = newVersion.split(".").map(Number);
  const oldParts = oldVersion.split(".").map(Number);

  for (let i = 0; i < Math.max(newParts.length, oldParts.length); i++) {
    const newPart = newParts[i] || 0;
    const oldPart = oldParts[i] || 0;

    if (newPart > oldPart) return true;
    if (newPart < oldPart) return false;
  }

  return false;
}

async function clearAllCaches() {
  try {
    if (!("caches" in window)) return false;

    const cacheKeys = await caches.keys();
    await Promise.all(
      cacheKeys.map((key) => {
        console.log("Deleting cache:", key);
        return caches.delete(key);
      })
    );
    console.log("All caches deleted");
    return true;
  } catch (error) {
    console.error("Failed to clear caches:", error);
    return false;
  }
}

async function removeAllServiceWorkers() {
  if (!("serviceWorker" in navigator)) return false;

  try {
    const registrations = await navigator.serviceWorker.getRegistrations();

    await Promise.all(
      registrations.map(async (registration) => {
        console.log("Unregistering service worker:", registration.scope);
        return registration.unregister();
      })
    );

    console.log("All service workers unregistered");
    return true;
  } catch (error) {
    console.error("Failed to remove service workers:", error);
    return false;
  }
}


export function useVersionCheck(version) {
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const storedVersion = localStorage.getItem(APP_VERSION_KEY);
        const isFirstLoad = !storedVersion;

        if (isFirstLoad) {
          localStorage.setItem(APP_VERSION_KEY, version);
          setIsChecking(false);
          return;
        }

        if (compareVersions(version, storedVersion)) {
          console.log(
            `Version update detected: ${storedVersion} -> ${version}`
          );

          await clearAllCaches();
          await removeAllServiceWorkers();

          const keysToPreserve = [
            "MemoryOSCurrentOrder",
            "MemoryOSUpsaleOffer",
            "MemoryOSuState",
            "MemoryOSPlanData",
            APP_VERSION_KEY
          ];

          const preservedValues = {};
          keysToPreserve.forEach(key => {
            const value = localStorage.getItem(key);
            if (value !== null) {
              preservedValues[key] = value;
            }
          });

          localStorage.clear();

          Object.entries(preservedValues).forEach(([key, value]) => {
            localStorage.setItem(key, value);
          });

          localStorage.setItem(APP_VERSION_KEY, version);
        }

        setIsChecking(false);
      } catch (error) {
        console.error("Version check failed:", error);
        setIsChecking(false);
      }
    };

    checkVersion();
  }, [version]);

  return isChecking;
}